export default {
    0: 'whatsapp.png',
    1: 'mercado-livre.png',
    2: 'bling.png',
    3: 'melhor-envio.png',
    4: 'iugu.png',
    5: 'citel.png',
    6: 'clear-sale.png',
    7: 'meta.png',
    8: 'google-shopping.png',
  };